module.exports = __webpack_public_path__ + "static/img/img_05.54f0f37c.png";